import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "etc-o",
  "use": "etc-o-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"etc-o\"><title>etc</title><path d=\"M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0zm0 18.75A8.75 8.75 0 1 1 18.75 10 8.75 8.75 0 0 1 10 18.75zm-5-10A1.25 1.25 0 1 0 6.25 10 1.25 1.25 0 0 0 5 8.75zm5 0A1.25 1.25 0 1 0 11.25 10 1.25 1.25 0 0 0 10 8.75zm5 0A1.25 1.25 0 1 0 16.25 10 1.25 1.25 0 0 0 15 8.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/etc-o.svg
// module id = ou0O
// module chunks = 6